var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBenefits = function SvgBenefits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefits_svg__a)",
    d: "M9.09 12.897a1.47 1.47 0 0 0-1.275-.73l-3.93.013a1.47 1.47 0 0 0-1.27.74L.66 16.33a1.47 1.47 0 0 0 .005 1.47l1.977 3.397c.264.454.75.732 1.275.73l3.931-.013a1.47 1.47 0 0 0 1.27-.74l1.954-3.41a1.47 1.47 0 0 0-.006-1.47zm-1.529 1.192 1.715 2.946-1.695 2.958-3.408.012-1.715-2.946L4.152 14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefits_svg__b)",
    d: "M19.823 7.147a1.47 1.47 0 0 0-1.275-.73l-3.931.014a1.47 1.47 0 0 0-1.27.739l-1.953 3.41a1.47 1.47 0 0 0 .005 1.47l1.977 3.398c.264.453.75.732 1.275.73l3.93-.014a1.47 1.47 0 0 0 1.27-.739l1.954-3.411a1.47 1.47 0 0 0-.005-1.47zm-1.53 1.193 1.715 2.946-1.694 2.957-3.409.012-1.714-2.946 1.694-2.958z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefits_svg__c)",
    d: "M8.62.73A1.47 1.47 0 0 0 7.345 0L3.414.014a1.47 1.47 0 0 0-1.27.739L.19 4.163a1.47 1.47 0 0 0 .005 1.47L2.173 9.03c.264.454.75.732 1.275.73l3.93-.013a1.47 1.47 0 0 0 1.27-.74l1.954-3.41a1.47 1.47 0 0 0-.005-1.47zM7.09 1.922l1.715 2.946L7.11 7.826l-3.409.012-1.714-2.946 1.694-2.958z",
    opacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefits_svg__a",
    x1: 5.867,
    x2: 5.867,
    y1: 21.927,
    y2: 12.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefits_svg__b",
    x1: 16.599,
    x2: 16.599,
    y1: 16.178,
    y2: 6.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefits_svg__c",
    x1: 5.396,
    x2: 5.396,
    y1: 9.76,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgBenefits;